import GlobalConst from "../constants/GlobalConst";

export const isPasswordValid = (password) => {
    return GlobalConst.FEATURES.TEMP_PWD.some(ep => {
        return atob(ep) === password;
    });
}